import PropTypes from 'prop-types'
import React from 'react'
import {connect} from 'react-redux'
import {Message, Segment, Button, Form} from 'semantic-ui-react'
import {loginAction} from '../../../../actions/authentication.actions'
import {Link} from 'react-router'

const {Field} = Form

class Login extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isLoading: false,
      hasError: false,
      error: undefined,
      email: '',
      password: ''
    }
  }
  handleLogin (e) {
    const email = e.target.elements.email.value
    const password = e.target.elements.password.value
    this.setState({
      isLoading: true
    })
    this.props.loginAction(email, password, (error) => {
      this.setState({
        isLoading: false,
        hasError: true,
        error: error,
        password: ''
      })
    })
  }

  onChange (e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }
  render () {
    let errorNode

    if (this.state.hasError) {
      errorNode = <Message negative>{this.state.error.response.data.message}</Message>
    }

    let resetNode

    if (this.props.isReset) {
      resetNode = <Message info>Password changed, you can login below</Message>
    }

    return (
      <Segment>
        <Form loading={this.state.isLoading} onSubmit={this.handleLogin.bind(this)}>
          <h2>Log in</h2>
          {errorNode}
          {resetNode}
          <Field>
            <label htmlFor='email'>Email</label>
            <input autoFocus type='email' value={this.state.email} id='email' name='email' onChange={this.onChange.bind(this)} />
          </Field>
          <Field>
            <label htmlFor='password'>Password</label>
            <input type='password' value={this.state.password} id='password' name='password' onChange={this.onChange.bind(this)} />
          </Field>
          <Button primary type='submit'>Log in</Button>
          {/*<Link style={{float: 'right'}} className='item' activeClassName='active' to='/auth/signup'>| Sign up</Link>*/}
          <Link style={{float: 'right'}} className='item' activeClassName='active' to='/auth/resetpassword'>Forgot password?&nbsp;</Link>

        </Form>
      </Segment>
    )
  }
}

Login.propTypes = {
  login: PropTypes.func
}

function mapStateToProps (state) {
  return state.authentication
}

export default connect(mapStateToProps, {loginAction})(Login)



// WEBPACK FOOTER //
// ./src/pages/auth/components/login/index.js